var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ExtensionsModules',{attrs:{"systemData":_vm.systemData,"fieldOfCareData":_vm.fieldOfCareData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }